//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CardSkeleton from '@/components/Skeletons/CardSkeleton'
import Promotor from '@/api/promotores/usuarios.api'
import PerfilEditDialog from './PerfilEditDialog'
import DireccionEditDialog from '../direccion/DireccionEditDialog'
import RolSelectChip from '../rol/RolSelectChip'
import StatusButton from '../status/StatusButton'

export default {
  components: {
    CardSkeleton,
    RolSelectChip,
    StatusButton,
  },
  data() {
    return {
      promotor: {
        rol: {}
      },
      loading: false,
    }
  },

  mounted() {
    this.loadPromotor()
  },

  methods: {
    async loadPromotor() {
      try {
        this.loading = true
        this.promotor = await Promotor.get(this.$route.params.promotor)
      } finally {
        this.loading = false
      }
    },

    openMatiDashboardUrl() {
      window.open(this.promotor.matiDashboardUrl, "_blank")
    },

    openPromotorEdit() {
      const dialog = this.$q.dialog({
        component: PerfilEditDialog,
        promotor: this.promotor
      })

      dialog.onOk((promotor) => {
        this.loadPromotor()
        dialog.hide()
      })
    },

    openDireccionDialog() {
      this.$q.dialog({
        component: DireccionEditDialog,
        promotorId: this.promotor.id,
      });
    },
  },
}
